import React from 'react'
import { QntmSystemConfigurationProvider } from 'src/Libs/shop/provider/shop-qntm-system-configuration-provider'
import QntmSystemConfigurationWrapper from './QntmSystemConfigurationWrapper'

/*
 * This component wraps normal system configuration with provider
 */
const QntmSystemConfiguration: React.FC = () => {
  return (
    <QntmSystemConfigurationProvider>
      <QntmSystemConfigurationWrapper />
    </QntmSystemConfigurationProvider>
  )
}

export default QntmSystemConfiguration
